<template>
    <b-modal id="modal-upload-document"
             centered
             v-model="isVisible"
             :title="$t('cdb.subscriptions.upload_documents')"
    >
        <div class="row">
            <div class="col-12">
                <b-form-file
                    v-model="fields.file.value"
                    :state="fields.file.state"
                    :placeholder="$t('cdb.subscriptions.no_file_chosen')"
                    :drop-placeholder="$t('cdb.subscriptions.drop_file_here')"
                    accept="application/pdf"
                    :browse-text="$t('cdb.subscriptions.choose')"
                    @change="checkFileSize"
                ></b-form-file>
                <div class="col-12 text-danger mt-2" v-if="fileSizeError">
                    {{ $t('cdb.subscriptions.upload_file_size_error') }}
                </div>

                <b-form-group
                    id="notice-group"
                    :label="$t('cdb.subscriptions.note')"
                    label-for="notice"
                    class="mt-3"
                >
                    <b-form-input
                        id="notice"
                        v-model="fields.notice.value"
                        type="text"
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="type-group"
                    :label="$t('cdb.subscriptions.document_type')"
                    label-for="type"
                    class="mt-3"
                >
                    <b-form-select v-model="fields.type.value">
                        <b-form-select-option value="null" disabled>{{ $t('cdb.subscriptions.documents.type.null') }}</b-form-select-option>
                        <b-form-select-option value="DAMAGE_REPORT">{{ $t('cdb.subscriptions.documents.type.damageReport') }}</b-form-select-option>
                        <b-form-select-option value="TICKET">{{ $t('cdb.subscriptions.documents.type.ticket') }}</b-form-select-option>
                        <b-form-select-option value="SPEED_TRAP_REPORT">{{ $t('cdb.subscriptions.documents.type.speedTrapReport') }}</b-form-select-option>
                        <b-form-select-option value="MISC">{{ $t('cdb.subscriptions.documents.type.misc') }}</b-form-select-option>
                        <b-form-select-option value="PROOF_OF_DISCOUNT">{{ $t('cdb.subscriptions.documents.type.proofOfDiscount') }}</b-form-select-option>
                    </b-form-select>
                </b-form-group>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="alert alert-success" v-if="isSubmitted">{{$t('cdb.subscriptions.upload_success_message')}}</div>
                <div class="alert alert-danger" v-if="error">{{$t('cdb.subscriptions.upload_error_message')}}</div>
            </div>
        </div>
        <template #modal-footer>
            <button type="button" class="btn btn-secondary" @click="abort">{{ $t('cdb.subscriptions.abort') }}</button>
            <button type="button" class="btn btn-primary" @click="submit" v-if="formIsValid && !isLoading">{{ $t('cdb.subscriptions.upload_file') }}</button>
            <button type="button" class="btn btn-primary disabled" v-if="!formIsValid && !isLoading">{{ $t('cdb.subscriptions.upload_file') }}</button>
            <button type="button" class="btn btn-primary disabled" v-if="formIsValid && isLoading">{{ $t('cdb.subscriptions.loading') }}</button>
        </template>
    </b-modal>
</template>

<script>
import { BModal, BFormFile, BFormGroup, BFormInput, BFormSelect, BFormSelectOption } from "bootstrap-vue";
import { EventBus } from '../../event-bus';

export default {
    name: 'ModalUploadDocument',
    components: {
        BModal, BFormFile, BFormGroup, BFormInput, BFormSelect, BFormSelectOption
    },
    data() {
        return {
            isVisible: false,
            isLoading: false,
            isSubmitted: false,
            error: false,
            file: null,
            fileSizeError: false,
            data: null,
            fields: this.getDefaultData()
        }
    },
    mounted() {
        EventBus.$on('init-upload-modal', this.getData);
    },
    methods: {
        checkFileSize(e) {
           if(e.target.files.length > 0 && e.target.files[0].size / 1000000 > 10) {
               this.fileSizeError = true;
           } else {
               this.fileSizeError = false;
           }
        },

        getDefaultData(){
            return {
                file: {
                    value: [],
                    state: null,
                },
                notice: {
                    value: '',
                    state: null,
                },
                type: {
                    value: null,
                    state: null,
                }
            }
        },
        getData(data) {
            this.isVisible = true
            this.data = data
        },
        submit(){
            this.isLoading = true
            this.isSubmitted = false
            this.error = false

            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }

            let formData = new FormData()
            formData.append('document', this.fields.file.value)
            formData.append('document_type', this.fields.type.value)
            formData.append('subscription_uuid', this.data.subscriptionData.uuid)
            formData.append('subsidiary_id', this.data.subscriptionData.subsidiary_id)
            formData.append('customer_notice', this.fields.notice.value)

            this.$axios.post(`api/v1/dashboard/upload_document`, formData, config)
                .then((data) => {
                    this.fields = this.getDefaultData()
                    this.isLoading = false
                    if(data.data === 'successful') {
                        this.getDefaultData()
                        this.isSubmitted = true
                    } else {
                        this.error = true
                    }

                    EventBus.$emit('cdb-reload-documents', null);
                }).catch(error => {
                    this.error = true
            });
        },
        abort(){
            this.isVisible = false
        }
    },
    computed: {
        formIsValid(){
            const { value } = this.fields.file
            if(value !== null && typeof value === 'object' && Object.keys(value).length > 0) {
                return this.fields.file.value.name && this.fields.type.value && !this.fileSizeError
            } else {
                return false
            }
        }
    }
}
</script>
